export default {
  itemsPerPage: 10,
};
